import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export type FeatureAccessVariant = 'feature' | 'error';

interface FeatureAccessStateProps {
  message: string;
  title?: string;
  variant?: FeatureAccessVariant;
  onRetry?: () => void;
  retryLabel?: string;
  /** `compact` para uso inline (modais); padrão é o espaçamento maior para página cheia. */
  compact?: boolean;
  className?: string;
}

const DEFAULT_TITLES: Record<FeatureAccessVariant, string> = {
  feature: 'Funcionalidade indisponível',
  error: 'Erro ao carregar',
};

export const FeatureAccessState: React.FC<FeatureAccessStateProps> = ({
  message,
  title,
  variant = 'feature',
  onRetry,
  retryLabel = 'Tentar novamente',
  compact = false,
  className = '',
}) => {
  const isFeature = variant === 'feature';
  const resolvedTitle = title ?? DEFAULT_TITLES[variant];
  const circleClass = isFeature ? 'bg-amber-100' : 'bg-red-100';
  const iconClass = isFeature ? 'text-amber-600' : 'text-red-600';

  return (
    <div className={`flex flex-col items-center gap-3 text-center ${compact ? 'py-6' : 'py-10'} ${className}`}>
      <div className={`flex items-center justify-center h-12 w-12 rounded-full ${circleClass}`}>
        <ExclamationTriangleIcon className={`h-6 w-6 ${iconClass}`} />
      </div>
      <div>
        <p className="font-medium text-gray-800">{resolvedTitle}</p>
        <p className="mt-1 text-sm text-gray-500 max-w-md">{message}</p>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
};
